import {
  TablePagination as MUITablePagination,
  TableRow as MUITableRow,
  styled,
} from "@material-ui/core";
import { TablePaginationActions } from "./TablePaginationActions";
import type { EditedRowProps, TableProps, TableRowDefinition } from "./types";

interface TablePaginationProps {
  numRows: number;
}

const Pagination = styled(MUITablePagination)({ borderBottom: "revert" });

// A plain table-row, not a flex row: MUI's pagination toolbar already
// right-aligns its controls via its own spacer, so flex was redundant — and
// a flex row collapses to shrink-to-fit under `tableLayout: fixed`, crushing
// the toolbar. Letting the footer cell span the columns keeps it working in
// both auto and fixed table layouts.
const Row = styled(MUITableRow)({
  borderBottom: "1px solid rgba(224, 224, 224, 1)",
});

const TablePagination = (
  props: TablePaginationProps & TableProps & EditedRowProps,
) => {
  const { numRows, pagination, columns, rows, editedRow, setEditedRow } = props;

  const pageSizes = pagination?.pageSizeOptions?.map((size) => {
    return { value: size, label: `${size} rows` };
  }) ?? [
    { value: 5, label: "5 rows" },
    { value: 10, label: "10 rows" },
    { value: 25, label: "25 rows" },
  ];

  return (
    <Row>
      <Pagination
        rowsPerPageOptions={pagination?.handlePageSizeChange ? pageSizes : []}
        colSpan={columns.length}
        count={numRows}
        rowsPerPage={pagination?.pageSize}
        page={pagination?.page}
        onPageChange={(event, page: number) => {
          setEditedRow({
            ...(rows[editedRow.index] as TableRowDefinition),
            index: null,
          });
          pagination?.handlePageChange(page, event);
        }}
        onRowsPerPageChange={(event) => {
          setEditedRow({
            ...(rows[editedRow.index] as TableRowDefinition),
            index: null,
          });
          const pageSize = parseInt(event.target.value, 10);
          pagination?.handlePageSizeChange(pageSize, event);
        }}
        labelRowsPerPage=""
        ActionsComponent={TablePaginationActions}
      />
    </Row>
  );
};

export default TablePagination;
